<template>
    <div class="container bottom">
        <link href="/static/css/cabinet/style.css" rel="stylesheet" />
        <div class="row">
            <div class="silca col-md-120">
                <router-link style="font-size: 16px;" class="previous" to="/cabinet/">← назад</router-link> | <b>ПРОМОКОД</b>
            </div>
            <div class="col-md-120 bonusu">
                <div class="row">
                    <div class="col-md-offset-30 col-md-60">
                        <div class="form-group">
                            <label for="messageSubject">Промокод</label>
                            <input type="text" class="form-control" id="messageSubject" name="code" v-model="code" placeholder="введите промокод">
                        </div>
                        <div class="alert alert-success col-md-120 success" v-if="status==='success'"><p v-for="(error, index) in errors" :key="index">{{error}}</p></div>
                        <div class="alert alert-danger col-md-120 fail" v-if="status==='fail'"><p v-for="(error, index) in errors" :key="index">{{error}}</p></div>
                        <div class="alert alert-warning col-md-120 empty" role="alert" v-if="status==='empty'"><p v-for="(error, index) in errors" :key="index">{{error}}</p></div>
                        <input type="button" id="checkCode" class="btn btn-primary" value="Проверить" @click="checkPromo">
                        <input type="submit" class="btn btn-primary" v-if="active" value="Активировать" @click="submitPromo">
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'promocode',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      status: null,
      code: null,
      errors: [],
      active: 0
    }
  },
  methods: {
    checkPromo () {
      this.errors = []
      this.status = null
      if (!this.code) {
        this.status = 'fail'
        this.errors.push('Вам необходимо указать промокод')
      }
      if (this.errors.length === 0) {
        var formData = new FormData()
        formData.append('code', this.code)
        axios.post('https://crm.v-avtoservice.com/list/check-promo?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.status = response.data.status
          this.errors.push(response.data.text)
          if (this.status === 'success') this.active = 1
        })
      }
    },
    submitPromo () {
      this.errors = []
      this.status = null
      if (!this.code) {
        this.status = 'fail'
        this.errors.push('Вам необходимо указать промокод')
      }
      if (this.errors.length === 0) {
        this.active = 0
        var formData = new FormData()
        formData.append('code', this.code)
        formData.append('activate', true)
        axios.post('https://crm.v-avtoservice.com/list/check-promo?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.status = response.data.status
          this.errors.push(response.data.text)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/promocode.vue